import React from 'react';
import { Star, MessageCircle } from 'lucide-react';
const testimonials = [{
  name: 'Daniela M.',
  initials: 'DM',
  role: 'Mamá primeriza · Bebé de 2 semanas',
  color: 'bg-lavender',
  message: 'Estaba llorando a las 3am sin saber qué hacer y me acordé que tenía el plan. Abrí el día 8 y solo seguí los pasos. No tuve que pensar. Eso fue todo lo que necesitaba. Ojalá alguien me lo hubiera regalado en el hospital. 💜',
  time: '3:47 AM',
  stars: 5
}, {
  name: 'Carolina R.',
  initials: 'CR',
  role: 'Mamá de mellizos · Semana 4',
  color: 'bg-sage',
  message: 'Mi esposo me preguntó "¿qué necesitas?" y por primera vez pude decirle exactamente qué, porque lo tenía en el plan. Los scripts para pedir ayuda me salvaron. Ya no me siento culpable por no poder sola. Este ebook debería venir con el alta médica. 🥺',
  time: '11:22 PM',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-310">
      <div className="max-w-3xl mx-auto" data-id="element-311">
        {/* Section header */}
        <div className="text-center mb-10" data-id="element-312">
          <div className="inline-flex items-center gap-2 mb-4" data-id="element-313">
            <MessageCircle className="w-5 h-5 text-lavender-dark" data-id="element-314" />
            <span className="text-sm font-semibold text-lavender-dark uppercase tracking-wide" data-id="element-315">
              Mamás reales, historias reales
            </span>
          </div>
          <h2 className="md:text-4xl font-bold text-text text-[36px]" data-id="element-316">
            Lo que dicen las mamás que ya lo tienen
          </h2>
        </div>

        {/* Testimonial cards */}
        <div className="space-y-6" data-id="element-317">
          {testimonials.map((t, idx) => <div key={idx} className="bg-cream rounded-2xl border border-lavender/20 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-318">
              {/* Header — profile info */}
              <div className="flex items-center gap-3 px-5 py-4 border-b border-lavender/10 pt-[20px] pb-[20px] pl-[5px] pr-[5px]" data-id="element-319">
                <div className={`w-10 h-10 ${t.color} rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0`} data-id="element-320">
                  {t.initials}
                </div>
                <div className="flex-1 min-w-0" data-id="element-321">
                  <p className="font-bold text-text text-sm" data-id="element-322">{t.name}</p>
                  <p className="text-xs text-text-light" data-id="element-323">{t.role}</p>
                </div>
                {/* Stars */}
                <div className="flex gap-0.5 flex-shrink-0" data-id="element-324">
                  {Array.from({
                length: t.stars
              }).map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-325" />)}
                </div>
              </div>

              {/* Message bubble */}
              <div className="px-5 py-4" data-id="element-326">
                <div className="bg-white rounded-2xl rounded-tl-sm px-4 py-3 shadow-sm border border-lavender/10 relative" data-id="element-327">
                  <p className="text-text/90 text-base leading-relaxed" data-id="element-328">
                    {t.message}
                  </p>
                  <p className="text-xs text-text-light/60 text-right mt-2" data-id="element-329">
                    {t.time}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Social proof footer */}
        <p className="text-center text-sm text-text-light mt-8 italic" data-id="element-330">
          💌 Mensajes reales de mamás que descargaron el plan
        </p>
      </div>
    </section>;
}